import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const headingVariants = cva('font-display leading-[1.1] text-text-primary', {
  variants: {
    size: {
      h1: 'text-[clamp(2.4rem,6vw,4.8rem)] font-extrabold tracking-[-0.03em]',
      h2: 'text-[clamp(1.8rem,4vw,3.2rem)] font-bold tracking-[-0.025em]',
      h3: 'text-[clamp(1.3rem,2.2vw,1.75rem)] font-semibold',
      h4: 'text-lg font-semibold',
    },
  },
  defaultVariants: { size: 'h2' },
})

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4'

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  as?: HeadingTag
}

export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, size = 'h2', as, ...props }, ref) => {
    const Comp = (as ?? size ?? 'h2') as HeadingTag
    return (
      <Comp
        ref={ref}
        className={cn(headingVariants({ size }), className)}
        {...props}
      />
    )
  },
)
Heading.displayName = 'Heading'
